import { CopyableValue, Text } from '@components/ui';
import Box from '@mui/material/Box';
import type { SxProps, Theme } from '@mui/material/styles';

export const jobFieldRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: { xs: 'flex-start', sm: 'center' },
  justifyContent: 'space-between',
  gap: { xs: '6px', sm: 0 },
  flexDirection: { xs: 'column', sm: 'row' },
  borderBottom: 1,
  borderColor: 'divider',
  py: '14px',
  '&:last-of-type': { borderBottom: 0 },
};

interface JobFieldProps {
  label: string;
  value?: string | number | null;
  wide?: boolean;
}

export const JobFacts = ({
  items,
}: {
  items: JobFieldProps[];
}): JSX.Element => (
  <Box
    sx={{
      display: 'grid',
      gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
      gap: 1.5,
    }}
  >
    {items.map((item) => (
      <Box
        key={item.label}
        sx={{
          gridColumn: item.wide ? '1 / -1' : undefined,
          borderRadius: 1,
          bgcolor: 'action.hover',
          px: 1.5,
          py: 1,
        }}
      >
        <Text
          as="span"
          variant="overline"
          tone="muted"
          sx={{ display: 'block' }}
        >
          {item.label}
        </Text>
        <Box
          sx={{
            mt: 0.25,
            fontSize: 14,
            fontWeight: 600,
            color: 'text.primary',
          }}
        >
          <CopyableValue value={item.value ?? undefined} />
        </Box>
      </Box>
    ))}
  </Box>
);

const JobField = ({ label, value }: JobFieldProps): JSX.Element => (
  <Box sx={jobFieldRowSx}>
    <Text as="span" variant="overline" tone="muted" sx={{ minWidth: 180 }}>
      {label}
    </Text>
    <Box
      sx={{
        textAlign: { xs: 'left', sm: 'right' },
        fontWeight: 500,
        fontSize: 16,
        color: 'text.primary',
      }}
    >
      <CopyableValue value={value ?? undefined} />
    </Box>
  </Box>
);

export default JobField;
